import httpClient from "../../httpClient";
import { API_DASHBOARD_STATS } from "../../config";

export const dashboardStats = {
    get: (params) => {
        const endpoint = `${API_DASHBOARD_STATS}?filter=${params}`;
        return httpClient.get(endpoint);
    },
};
